export default __webpack_public_path__ + "static/media/Animals_16.7997feb2.png";